module.exports = __webpack_public_path__ + "f661639d0228437d429a5e080d725f1a.png";